__turbopack_context__.v({
  "backButton": "styles-module-scss-module__BbKvCW__backButton",
  "detailsInfo": "styles-module-scss-module__BbKvCW__detailsInfo",
  "header": "styles-module-scss-module__BbKvCW__header",
  "root": "styles-module-scss-module__BbKvCW__root",
  "section": "styles-module-scss-module__BbKvCW__section",
});
